const ns = {};

/**
 * Diese Klasse ermoeglicht das Ausfuehren von Code beim Vorhandensein eines
 * definierten Layouts (z. B. soll bestimmtes JavaScript nur bei Layout XY
 * ausgefuehrt werden, also nutzt man diesen Handler um das festzulegen).
 *
 * Hier gehoert kein layout-spezifischer Code rein!
 *
 */
ns.LayoutHandler = function() {

    this.bindings = {};
    this.init();
};

ns.LayoutHandler.prototype.init = function() {

    var self = this;

    $(function () {
        // we will use the modern as default theme!
        var theme = 'modern';
        var masterTheme = $('body').attr('data-layout');
        var secondTheme = $('body').attr('data-layout-second');
        if (masterTheme && self.bindings[masterTheme]) {
            theme = masterTheme;
        }
        else if (secondTheme && self.bindings[secondTheme]) {
            theme = secondTheme;
        }
        if (self.bindings[theme]) {
            $(self.bindings[theme]).each(function (idx, el) {
                (typeof el === 'function') && el();
            });
        }
    });
};

/**
 *
 * @param {type} layout
 * @param {type} func
 * @returns {undefined}
 */
ns.LayoutHandler.prototype.on = function(layout, func) {

    if (!this.bindings[layout]) {
        this.bindings[layout] = [];
    }

    this.bindings[layout].push(func);
};

export default new ns.LayoutHandler();
